import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-d-flex p-m-3 p-p-2 p-mt-4 p-mb-3 p-pl-2 w-100 p-text-left",
  style: {"border-left":"solid 5px black"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold f-size-20" }, "ประวัติการซื้อสินค้า")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionList = _resolveComponent("TransactionList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionList, {
        transactionList: _ctx.transactionList,
        onInfiniteHandler: _ctx.infiniteHandler
      }, null, 8, ["transactionList", "onInfiniteHandler"])
    ])
  ]))
}